import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { OliveIcon } from '../components/OliveIcon';
import { OliveDrawer } from '../OliveDrawer/OliveDrawer';
import '../OliveAdvisor.css';
import { useOliveAdvisorEnabled } from 'enrollment/features/OliveAdvisor/components/OliveAdvisorEnabled';
import { BenefitPlansDto } from 'enrollment/queries/useBenefitPlansQuery/types';

export interface BenefitDataState {
  state: {
    currentBenefitCategory: string;
    benefitData?: BenefitPlansDto;
    pendedBenefitData?: BenefitPlansDto;
    contextLookup?: string;
    fromReview?: boolean;
    benefitId?: number;
    preElectedPlan?: boolean;
    currentCategory?: string;
  };
}
export const OliveBanner = () => {
  const { t } = useTranslation('oliveAdvisor');
  const [bannerChatValue, setBannerChatValue] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false); // Loading state

  const isMobile = window.innerWidth < 744;
  const isDevice = window.innerWidth < 1200;

  const showOliveAdvisor = window.location.pathname.includes('/plans');
  const location = useLocation() as BenefitDataState;
  const benefit = location.state?.benefitData?.benefit;
  const benefitName = benefit?.org_benefit_name.toLowerCase();

  const oliveAdvisorEnabled =
    useOliveAdvisorEnabled() && benefitName === 'medical';

  function handleChatSend(e: React.FormEvent) {
    e.preventDefault();
    const bannerChat = document.getElementById('oliveChat') as HTMLInputElement;
    setBannerChatValue(bannerChat.value); // Update bannerChatValue
    setLoading(true);
    handleDrawer();
    bannerChat.value = '';
  }

  function handleDrawer() {
    const drawer = document.getElementById('olive-drawer') as HTMLDialogElement;
    if (drawer) {
      drawer.showModal();
      drawer.classList.add('open');
      drawer.style.display = 'flex';
      document.documentElement.style.overflow = 'hidden';
    }
  }

  if (oliveAdvisorEnabled) {
    return (
      <>
        {showOliveAdvisor && (
          <>
            <form onSubmit={handleChatSend}>
              <div id="olive-advisor" className="d-flex">
                <OliveIcon />
                <label htmlFor="oliveChat" className="sr-only">
                  {t('searchLabel')}
                </label>
                {isDevice && (
                  <input
                    type="text"
                    id="oliveChat"
                    placeholder={
                      isMobile ? t('mobileSearch') : t('searchLabel')
                    }
                    className="form-control"
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleChatSend(e);
                      }
                    }}
                  />
                )}
                {!isDevice && (
                  <textarea
                    id="oliveChat"
                    placeholder={t('searchLabel')}
                    className="form-control"
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !loading) {
                        handleChatSend(e);
                      }
                    }}
                  />
                )}
                <button
                  id="chat-send"
                  className="btn btn-icon"
                  type="submit"
                  disabled={loading} // Disable button if response is loading
                >
                  <span className="sr-only">{t('searchButton')}</span>
                  <i className="ph ph-magnifying-glass"></i>
                </button>
              </div>
            </form>
            <button id="chat-toggle" onClick={handleDrawer}>
              <i className="ph ph-caret-double-left"></i>
            </button>
          </>
        )}

        <OliveDrawer
          userQuery={bannerChatValue}
          loading={loading}
          setLoading={setLoading}
        />
      </>
    );
  }
  return null;
};
